module.exports = __webpack_public_path__ + "img/智慧工厂数字化管理系统.8cf14e3b.png";